import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, TrendingUp } from "lucide-react";
import { useLang, tx } from "./i18n";
import { Counter } from "./bits";

export const CaseVisual = ({ c, className = "" }) => (
  <div className={`relative overflow-hidden bg-[#0A1128] ${className}`}>
    {c.cover_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${c.cover_url}`} alt={c.nome} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      : (
        <div className="absolute inset-0" aria-hidden>
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#E8173A]/90 blur-[2px]" />
          <div className="absolute right-6 top-6 h-40 w-40 rounded-full border-2 border-[#7CC6FA]/40" />
          <div className="absolute right-[-30px] top-[-10px] h-64 w-64 rounded-full border border-[#7CC6FA]/25" />
        </div>
      )}
    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128]/85 via-[#0A1128]/20 to-transparent" />
    <div className="absolute left-5 bottom-5 right-5 flex items-end gap-3">
      {c.logo_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${c.logo_url}`} alt="" className="h-14 w-14 rounded-2xl bg-white object-contain p-1.5 shrink-0" />
        : <div className="h-14 w-14 rounded-2xl bg-[#7CC6FA] text-[#0A1128] font-display font-black text-lg flex items-center justify-center shrink-0">{c.nome.split(/\s+/).slice(0, 2).map((w) => w[0]).join("")}</div>}
      <div className="min-w-0 text-white font-display font-black text-xl leading-tight">{c.nome}</div>
    </div>
  </div>
);

export const KpiStrip = ({ c, big }) => {
  const { lang } = useLang();
  if (!c.kpi?.length) {
    return <div className="inline-flex items-center gap-2 rounded-full bg-[#7CC6FA]/30 px-3 py-1.5 text-sm font-bold text-[#0A1128]" data-testid={`case-esito-${c.slug}`}><TrendingUp className="h-4 w-4 text-[#E8173A]" />{tx(c.esito, lang) || (lang === "en" ? "Growth in progress" : "Crescita in corso")}</div>;
  }
  return (
    <div className={`grid gap-3 ${big ? "grid-cols-2 sm:grid-cols-3" : "grid-cols-2"}`}>
      {c.kpi.map((k, i) => (
        <div key={i} className="rounded-2xl bg-[#EAF6FF] border border-[#7CC6FA]/60 px-4 py-3" data-testid={`case-kpi-${c.slug}-${i}`}>
          <div className={`font-display font-black text-[#E8173A] leading-none ${big ? "text-4xl" : "text-3xl"}`}><Counter value={k.valore} /></div>
          <div className="mt-1.5 text-xs font-bold text-[#0A1128]">{tx(k.label, lang)}</div>
          {tx(k.periodo, lang) && <div className="text-[11px] text-slate-500">{tx(k.periodo, lang)}</div>}
        </div>
      ))}
    </div>
  );
};

export const CaseCard = ({ c }) => {
  const { lang, t } = useLang();
  return (
    <article className="group h-full flex flex-col rounded-[28px] bg-white overflow-hidden shadow-[0_18px_50px_rgba(10,17,40,0.10)] hover:shadow-[0_26px_70px_rgba(10,17,40,0.18)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300" data-testid={`case-card-${c.slug}`}>
      <Link to={`/case-history/${c.slug}`} className="block"><CaseVisual c={c} className="h-56" /></Link>
      <div className="flex-1 flex flex-col p-6 gap-4">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.18em] text-[#E8173A]">{tx(c.settore, lang)}</div>
          <p className="mt-2 text-[15px] text-slate-600 leading-relaxed">{tx(c.sintesi, lang)}</p>
        </div>
        <KpiStrip c={c} />
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-2">
          <Link to={`/case-history/${c.slug}`} className="inline-flex items-center gap-1.5 h-11 px-5 rounded-full bg-[#0A1128] text-white text-sm font-bold hover:bg-[#E8173A] transition-colors" data-testid={`case-open-${c.slug}`}>{t.casi.open}<ArrowUpRight className="h-4 w-4" /></Link>
          {c.instagram && <a href={c.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 h-11 px-4 rounded-full border border-[#0A1128]/15 text-sm font-bold text-[#0A1128] hover:border-[#E8173A] hover:text-[#E8173A] transition-colors" data-testid={`case-ig-${c.slug}`}><Instagram className="h-4 w-4" />{t.casi.ig}</a>}
        </div>
      </div>
    </article>
  );
};
